// React Lib
import React, { useState } from "react";
// Component Styles
import { useStyles } from "./TopNavbarStyles";
// @otg-one/ui_components/components
import { Button } from '../index';
// @otg-one/ui_components/icons
import { Settings } from "../../sap_icons";
import { OntegoOneLogoWhiteAlt, AvatarUser } from '../../icons';
// @otg-one/ui_components/constants
import { Color } from "../../constants";
// Material UI Core
import Fade from '@mui/material/Fade';
const AccountBox = (props) => {
    const classes = useStyles(props);
    const { avatar, avatarKey, onAccountBoxClick } = props;
    return (React.createElement(React.Fragment, null, avatar ? (React.createElement("div", { className: classes.topNavbarAccountImage, onClick: onAccountBoxClick },
        React.createElement("img", { key: avatarKey, src: avatar, alt: "avatar", style: {
                width: 32,
                height: 32,
                borderRadius: "50%"
            } }))) : (React.createElement(AvatarUser, { style: { width: 32, height: 32, marginRight: 24, color: Color.primary[100], cursor: "pointer" }, onClick: onAccountBoxClick }))));
};
export const TopNavbar = (props) => {
    const classes = useStyles(props);
    const [isMegaDropdownOpen, setIsMegaDropdownOpen] = useState(false);
    const { id, avatar, avatarKey, onLogoClick, onSettingsClick, onAccountBoxClick, onLogoutClick, onGetTheAppClick, onPricingAndLicenseClick, megaDropdownComponents, textGetTheApp, textPricingAndLicense, textLogout } = props;
    const handleOpenMegaDropdown = () => {
        setIsMegaDropdownOpen(true);
    };
    const handleCloseMegaDropdown = () => {
        setIsMegaDropdownOpen(false);
    };
    return (React.createElement("div", { className: classes.topNavbarContainer },
        React.createElement("div", { className: classes.topNavbar },
            React.createElement("div", { className: classes.topNavbarIcon },
                React.createElement(OntegoOneLogoWhiteAlt, { className: classes.topNavbarLogo, onClick: onLogoClick })),
            React.createElement("div", { className: classes.topNavbarChildContainer },
                React.createElement(Button, { type: "secondary", color: "white", onClick: onGetTheAppClick, style: { outline: 'none', marginRight: 30 } }, textGetTheApp),
                React.createElement(Button, { type: "secondary", color: "white", onClick: onPricingAndLicenseClick, style: { outline: 'none', marginRight: 10 } }, textPricingAndLicense),
                React.createElement("div", { className: classes.topNavbarSettingsIconContainer, style: {
                        backgroundColor: isMegaDropdownOpen ? Color.neutral[0] : "transparent",
                    }, onMouseOver: handleOpenMegaDropdown, onMouseOut: handleCloseMegaDropdown },
                    React.createElement(Settings, { className: classes.topNavbarSettingsIcon, style: { color: isMegaDropdownOpen ? Color.primary[700] : Color.primary[100] }, onClick: onSettingsClick })),
                React.createElement(AccountBox, { avatarKey: avatarKey, avatar: avatar, onAccountBoxClick: onAccountBoxClick }),
                React.createElement(Button, { id: `${id}logoutButton`, color: "white", onClick: onLogoutClick, style: { outline: 'none', } }, textLogout))),
        React.createElement(Fade, { in: isMegaDropdownOpen, timeout: 200 },
            React.createElement("div", { className: classes.topNavbarChildDropdown, onMouseOver: handleOpenMegaDropdown, onMouseOut: handleCloseMegaDropdown }, megaDropdownComponents))));
};
TopNavbar.defaultProps = {
    avatar: null,
    avatarKey: "",
    onLogoClick: () => { },
    onPricingAndLicenseClick: () => { },
    onGetTheAppClick: () => { },
    onSettingsClick: () => { },
    onAccountBoxClick: () => { },
    onLogoutClick: () => { },
    megaDropdownComponents: React.createElement(React.Fragment, null),
    textGetTheApp: 'Get the App',
    textPricingAndLicense: 'Pricing And License',
    textLogout: 'Logout',
};
export default React.memo(TopNavbar);
